export const IMAGE_ERROR_CODE = {
  UPLOADIMAGE001: 'UPLOADIMAGE001',
  UPLOADIMAGE002: 'UPLOADIMAGE002',
  UPLOADIMAGE003: 'UPLOADIMAGE003',
};

export const IMAGE_ERROR_MESSAGE = {
  [IMAGE_ERROR_CODE.UPLOADIMAGE001]: '이미지 파일이 존재하지 않거나, 유효하지 않은 이미지 파일입니다.',
  [IMAGE_ERROR_CODE.UPLOADIMAGE002]: '이미지 파일은 최대 20MB 까지만 업로드 가능합니다.',
  [IMAGE_ERROR_CODE.UPLOADIMAGE003]: 'jpeg, jpg, png, gif 이미지만 업로드 가능합니다.',
};
